// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"K4-z"};